
interface IInfoBoxProps {
    title: string;
    children: React.ReactNode;
    }

export default function InfoBox(props: IInfoBoxProps) {
  return (
    <div className="info-box">
      <h3 className="info-box-title">{props.title}</h3>
      {props.children}
    </div>
  );
};


